/* Nutri Peak - scroll reveal.
   Uses rect checks rather than IntersectionObserver because the theme's
   smooth-scroll library transforms the scroll container, which makes
   observer intersection unreliable. Always fails open: if anything goes
   wrong the content is revealed rather than left invisible. */
(function () {
  'use strict';

  var ticking = false;

  function reveal(node) {
    if (node && !node.classList.contains('np-in')) node.classList.add('np-in');
  }

  function check() {
    ticking = false;
    var nodes = document.querySelectorAll('[data-np-reveal]:not(.np-in)');
    if (!nodes.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;

    Array.prototype.forEach.call(nodes, function (n) {
      var r = n.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) reveal(n);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(check);
  }

  function revealAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-np-reveal]'), reveal);
  }

  function start() {
    check();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', check);

    // Poll briefly for late-rendered sections
    var n = 0;
    var iv = setInterval(function () {
      n++;
      check();
      if (n > 20) clearInterval(iv);
    }, 250);

    // Safety net: never leave content hidden
    setTimeout(revealAll, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
